var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Effect',{attrs:{"params":_vm.params,"effect-node":_vm.delayNode,"icon":"icons/delay.svg","name":"delay"}})
}
var staticRenderFns = []

export { render, staticRenderFns }